import { History, createBrowserHistory } from 'history'
import { PUBLIC_URL } from 'config'

export const history: History = createBrowserHistory({ basename: PUBLIC_URL })
